/**
 * Doc Bailey's - Cart drawer mix & match upsell (UI only)
 * ---------------------------------------------------------------
 * Renders $14.95 add-on bottle buttons in the cart drawer and adds
 * them via /cart/add.js.
 *
 * Pricing correction and drawer refresh are NOT handled here directly.
 * After a successful add, this calls window.dbReconcileCart() (defined in
 * snippets/db-bottle-price-reconcile.liquid), which always performs its
 * own fresh /cart/update.js call and returns current, authoritative
 * section HTML - applied via window.dbApplyCartDrawerSections(). If that
 * doesn't apply for any reason, this falls back to a full reload rather
 * than leaving a stale cart on screen - the add itself already succeeded
 * by that point.
 */
(function () {
  'use strict';

  function routes() {
    return window.routes || {};
  }

  function showError(root, message) {
    var el = root.querySelector('.cart-mix-match__error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  class CartMixMatchElement extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      var button = event.target.closest('.cart-mix-match__card');
      if (!button || button.disabled) return;

      var variantId = parseInt(button.dataset.variantId, 10);
      if (isNaN(variantId)) return;

      event.preventDefault();
      this.addAddon(variantId, button);
    }

    addAddon(variantId, button) {
      var root = this;
      var errorEl = root.querySelector('.cart-mix-match__error');
      if (errorEl) errorEl.hidden = true;

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      fetch(routes().cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add that bottle.');
            return data;
          });
        })
        .then(function () {
          return window.dbReconcileCart ? window.dbReconcileCart() : Promise.resolve(null);
        })
        .then(function (sections) {
          var applied = sections && window.dbApplyCartDrawerSections
            ? window.dbApplyCartDrawerSections(sections)
            : false;
          if (!applied) {
            window.location.reload();
            return;
          }
          button.textContent = 'Added';
          setTimeout(function () {
            button.removeAttribute('aria-busy');
            button.disabled = false;
          }, 1200);
        })
        .catch(function (error) {
          console.error('[cart-mix-match] add failed', error);
          showError(root, error.message || 'Could not add that bottle. Please try again.');
          button.removeAttribute('aria-busy');
          button.disabled = false;
        });
    }
  }

  if (!customElements.get('cart-mix-match')) {
    customElements.define('cart-mix-match', CartMixMatchElement);
  }
})();
